import { DARK_GREEN_OPPS, DARK_RED_OPPS } from '../pages/opportunitiesByChannel/constants';
import { perc2color } from './colors';

const LIGHT_GREEN = '#e6fae6';
const DARK_GREEN = '#05c505';
const LIGHT_RED = '#ffe7e7';

// Spend = no color
// Opportunities Generated =  -1 (less is bad)
// Opportunities Closed = -1 (less is bad)
// Sales = -1 (less is bad)
// Cost per Opportunity = 1 (more is bad)
// Return on Marketing Investment = -1 (less is bad)
// Average Job Size = -1 (less is bad)
// Close Rate = -1 (less is bad)
// Cancellation Rate = 1 (more is bad)

const getGradientType = (name) => {
  if (name === 'Spend') {
    return 0;
  }
  if (
    [
      'Opportunities Generated',
      'Opportunities Closed',
      'Sales',
      'Return on Marketing Investment',
      'Average Job Size',
      'Close Rate',
    ].includes(name)
  ) {
    return -1;
  }
  if (['Cost per Opportunity', 'Cancellation Rate'].includes(name)) {
    return 1;
  }

  // for OppsByChannelTab
  if (
    ['Average_Job_Size', 'Yield_Gross', 'Close_Rate_Gross', 'Net_Conversion', 'romi'].includes(name)
  ) {
    return 2;
  }

  // for plan percentage fields
  if (['opps_perc_to_plan', 'spend_to_plan_ytd'].includes(name)) {
    return 3;
  }
};

// Helper function to handle type 1 gradient (lower is green, higher is red)
/**
 * @param parsedValue
 */
function applyType1Gradient(parsedValue) {
  const val = {};

  if (parsedValue < 100) {
    parsedValue = parsedValue <= 0 ? 1 : parsedValue;
    val.backgroundColor = perc2color(parsedValue / 100, LIGHT_GREEN, DARK_GREEN);
  } else {
    parsedValue = parsedValue - 100 || 1;
    parsedValue = parsedValue > 100 ? 100 : parsedValue;
    val.backgroundColor = perc2color(parsedValue / 100, DARK_RED_OPPS, LIGHT_RED);
  }
  return val;
}

// Helper function to handle type 2 gradient (for OPPSBYCHANNEL TAB)
/**
 * @param value
 */
function applyType2Gradient(value) {
  const val = {};

  if (value?.percent < 0) {
    return val;
  }

  if (value?.percent >= value?.avgValueForColumn) {
    val.backgroundColor = perc2color(value?.percent / 100, DARK_GREEN_OPPS, LIGHT_GREEN);
  } else if (value?.percent < value?.avgValueForColumn || value?.percent === 0) {
    val.backgroundColor = perc2color(value?.percent / 100, LIGHT_RED, DARK_RED_OPPS);
  }
  return val;
}

// Helper function to handle type 3 gradient (for plan percentage fields)
/**
 * @param parsedValue
 */
function applyType3Gradient(parsedValue) {
  const val = {};

  if (parsedValue >= 90) {
    const greenPercentage = Math.min((parsedValue - 90) / 20, 1);

    val.backgroundColor = perc2color(greenPercentage, DARK_GREEN, LIGHT_GREEN);
    return val;
  }

  if (parsedValue < 75) {
    if (parsedValue <= 50) {
      val.backgroundColor = DARK_RED_OPPS;
    } else {
      const redPercentage = (75 - parsedValue) / 25;

      val.backgroundColor = perc2color(redPercentage, DARK_RED_OPPS, LIGHT_RED);
    }
  }

  return val;
}

// Helper function to handle default gradient (lower is red, higher is green)
/**
 * @param parsedValue
 */
function applyDefaultGradient(parsedValue) {
  const val = {};

  if (parsedValue >= 100) {
    parsedValue = parsedValue - 100 || 1;
    parsedValue = parsedValue > 100 ? 100 : parsedValue;
    val.backgroundColor = perc2color(parsedValue / 100, DARK_GREEN_OPPS, LIGHT_GREEN);
    return val;
  }

  parsedValue = parsedValue <= 0 ? 1 : parsedValue;
  val.backgroundColor = perc2color(parsedValue / 100, LIGHT_RED, DARK_RED_OPPS);
  return val;
}

/**
 * @param rowName
 * @param value
 * @param totalBoolean
 */
export function getColorStyleForCell(rowName, value, totalBoolean) {
  const type = getGradientType(rowName);

  const val = {};

  // to avoid gradient color to total block
  if (totalBoolean) {
    return val;
  }

  if (![1, -1, 2, 3].includes(type)) {
    return val;
  }

  const parsedValue = parseFloat(value);

  if (!parsedValue && type !== 2 && type !== 3) {
    return val;
  }

  if (type === 1) {
    return applyType1Gradient(parsedValue);
  }

  if (type === 2) {
    return applyType2Gradient(value);
  }

  if (type === 3) {
    return applyType3Gradient(parsedValue);
  }

  return applyDefaultGradient(parsedValue);
}
